import * as z from "zod";

import { StoreSchema } from "../shared/store";

export const listStores = {
  name: "listStores" as const,
  input: z.object({}),
  output: z.object({ stores: z.array(StoreSchema) }),
};
